import { Result } from 'antd';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { PageLoading } from 'components/atoms/loading';
import { saveFields } from 'data/fields';
import { useAccount } from 'hooks/use-account';
import { useTaskFieldsQuery } from 'queries';

export const TaskFieldsProvider: FC<React.PropsWithChildren<unknown>> = (
  props,
) => {
  const { children } = props;
  const dispatch = useDispatch();
  const { isLoading, isError } = useTaskFieldsQuery({
    onSuccess: (result) => {
      // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
      dispatch(saveFields(result));
    },
  });

  const { accountId } = useAccount();

  if (isError) {
    /* TODO:: Can be improved. */
    return (
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong. Please refresh the page."
      />
    );
  }

  if (accountId && !isLoading) {
    return <>{children}</>;
  }

  return <PageLoading size="large" />;
};
